import { FC } from "react";

import { StepManualMeasurements } from "@/components/Procedures/Checklist/Step/StepManualMeasurements";
import StepMeasurementListeners from "@/components/Procedures/Checklist/Step/StepMeasurementListeners";
import { CheckpointType } from "@/components/Procedures/Types/ManualChecklistTypes";

import { ListenerTag } from "@/model/Procedure/ListenerTag";
import { ProcedureNodeStep } from "@/model/Procedure/ProcedureNodeStep";

export interface StepMeasurementsProps {
	activeSchemeId: number | undefined;
	autoMode: boolean;
	listenerTags: Array<ListenerTag>;
	showMeasurements: boolean;
	step: ProcedureNodeStep;
	setShowMeasurements: (show: boolean) => void;
	isActiveStep: boolean;
}

export const StepMeasurements: FC<StepMeasurementsProps> = (props) => {
	if (props.step?.CheckpointType === CheckpointType.ManualMeasurement) {
		return <StepManualMeasurements {...props} />;
	}

	return <StepMeasurementListeners {...props} />;
};
